import React from "react";
import { useHistory } from "react-router-dom";
import { API_URL } from "../constant";
import { App } from "../firebase";

function RecapRDV() {
  const history = useHistory();
  const [loading, setLoading] = React.useState(false);
  const cart = history.location.state.cart;
  const professionnel = history.location.state.professionnel;
  const productStaffs = history.location.state.productStaffs;
  const [prestations, setPrestations] = React.useState([]);
  const [size, setSize] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  React.useEffect(() => {
    loadPrestation();
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function loadPrestation() {
    var prestas = [];
    var pres = professionnel && professionnel.prestations;
    if (pres) {
      cart.products.map((d) => {
        Object.keys(pres).map((keyName) => {
          pres[keyName].map((p) => {
            if (d.productId === p.id) {
              let pro = p;
              pro.staffs = d.staffs;
              prestas.push(pro);
            }
          });
        });
      });
    }
    setPrestations(prestas);
  }

  function timeConvert(n) {
    var num = n;
    var hours = num / 60;
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);

    if (rhours > 0) {
      return rhours + "h " + rminutes + " min.";
    } else {
      return num + " min.";
    }
  }

  const updateCartInfo = (productId, staffId, cart, user) => {
    fetch(API_URL + "cart", {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        cartId: cart,
        userId: user,
        productId: productId,
        staffId: staffId,
      }),
    })
      .then(() => {
        console.log("assigné");
      })
      .catch((err) => {
        console.log(err);
        // alert("une erreur s'est produite");
      });
  };

  const Prestat = ({ item }) => {
    var datauser = {};
    if (item.staff) {
      productStaffs.map((p) => {
        if (p.productId === item.id) {
          p.staffs.map((u) => {
            if (item.staff == u.staffId) {
              datauser = u;
            }
          });
        }
      });
    }

    if (
      !(datauser && datauser.staffId) &&
      productStaffs &&
      productStaffs[0].staffs[0]
    ) {
      //on auto assigne
      updateCartInfo(
        item.id,
        productStaffs[0].staffs[0].staffId,
        cart.id,
        cart.userId
      );
    }
    return (
      <div className="content-bloc" style={{ width: "100%" }}>
        <div
          className="content-sha"
          style={{ padding: "10px 30px", overflow: "visible" }}
        >
          <div
            class="row"
            style={{ flexDirection: size.width <= 830 && "column" }}
          >
            <div
              class="col-50"
              style={{
                alignContent: "center",
                margin: size.width > 830 ? "auto" : "35px 0px",
              }}
            >
              <p
                className="raleway-normal-silver-18px "
                style={{ fontSize: size.width <= 428 && "15px" }}
              >
                {item.name} - {timeConvert(item.time)} -{" "}
                {(item.price / 100).toFixed(2)}€
              </p>
            </div>
            <div
              class="col-25"
              style={{
                display: "flex",
                margin: size.width > 830 && "auto",
              }}
            >
              <button
                className="raleway-bold-black-16px"
                //   onClick={ctaClickHandler}
                style={{
                  width: 138,
                  padding: "10px 23px",
                  backgroundColor: "#fff",
                  border: "2px solid black",
                  borderRadius: 10,
                  justifyContent: "left",
                  display: "flex",
                  marginRight: 38,
                }}
              >
                {datauser && datauser.staffId
                  ? datauser.prenom ||
                    datauser.name ||
                    datauser.email.split("@")[0]
                  : productStaffs && productStaffs[0].staffs[0]
                  ? productStaffs[0].staffs[0].prenom ||
                    productStaffs[0].staffs[0].name ||
                    productStaffs[0].staffs[0].email.split("@")[0]
                  : "Choix auto"}
              </button>
              <a
                onClick={() => {
                  history.push({
                    pathname: "/prise-de-rendez-vous/" + item.id,
                    state: professionnel,
                  });
                }}
                className="raleway-normal-black-16px "
                style={{
                  fontSize: "16px",
                  alignSelf: "center",
                  alignContent: "right",
                }}
              >
                <u>Modifier</u>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const getD = () => {
    const d = new Date(cart.date);
    var n = d.toLocaleDateString("fr-FR", {
      weekday: "long",
      month: "long",
      year: "numeric",
      day: "numeric",
    });
    return (
      n.charAt(0).toUpperCase() +
      n.slice(1) +
      " - " +
      (d.getHours() > 9 ? d.getHours() : "0" + d.getHours()) +
      ":" +
      (d.getMinutes() > 9 ? d.getMinutes() : "0" + d.getMinutes())
    );
  };

  const cancelCart = () => {
    //annuler tout le panier

    // eslint-disable-next-line no-restricted-globals
    if (confirm("Êtes-vous sur d'abandonner la réservation ?")) {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        cartId: cart.id,
        userId: App.auth().currentUser.uid,
      });
      var requestOptions = {
        method: "DELETE",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      setLoading(true);
      fetch(API_URL + "cart", requestOptions)
        .then((res) => res.json())
        .then((data) => {
          setLoading(false);
          if (data.success) {
            history.push("/");
          } else {
            alert("Une erreur s'est produite");
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
          alert("Une erreur s'est produite");
        });
    }
  };

  const calPrice = () => {
    var priceT = 0;
    prestations.forEach((p) => {
      priceT += p.price;
    });
    var t = priceT * (professionnel.acompte / 100) + 100;
    return (t / 100).toFixed(2);
  };
  return (
    <>
      <div class="row" style={{ maxWidth: 784, margin: "60px auto" }}>
        <div
          class="col-75"
          style={{
            margin: size.width <= 428 && "auto",
            // marginLeft: size.width <= 428 && 20,
            // marginRight: size.width <= 428 && 20,
          }}
        >
          {professionnel ? (
            <>
              <div class="container" style={{ padding: 0 }}>
                <h4 className="h4">{professionnel.name}</h4>
                <p
                  className="raleway-medium-dove-18px"
                  style={{ marginTop: 10, marginBottom: 35 }}
                >
                  {professionnel.adresse +
                    " " +
                    professionnel.zipcode +
                    " " +
                    professionnel.city}
                </p>
              </div>
              <div class="container" style={{ padding: 0 }}>
                <div class="vous-avez-dj-un-compte raleway-bold-eerie-black-20px">
                  Prestation choisie
                </div>
                {prestations && prestations.map((a) => <Prestat item={a} />)}
              </div>

              <div
                class="container"
                style={{ paddingTop: "35px", paddingLeft: 0, paddingRight: 0 }}
              >
                <div class="vous-avez-dj-un-compte raleway-bold-eerie-black-20px">
                  Date et heure
                </div>
                <div className="content-bloc" style={{ width: "100%" }}>
                  <div className="content-sha" style={{ padding: "10px 30px" }}>
                    <div
                      class="row"
                      style={{ flexDirection: size.width <= 830 && "column" }}
                    >
                      <div
                        class="col-50"
                        style={{
                          alignContent: "center",
                          margin: size.width > 830 ? "auto" : "35px 0px",
                        }}
                      >
                        <p className="raleway-normal-silver-18px ">
                          {cart && getD()}
                        </p>
                      </div>
                      <div
                        class="col-25"
                        style={{
                          display: "flex",
                          margin: size.width > 830 && "auto",
                        }}
                      >
                        {size.width > 830 && (
                          <button
                            className="raleway-bold-black-16px"
                            //   onClick={ctaClickHandler}
                            style={{
                              padding: "18px 23px",
                              backgroundColor: "#fff",
                              border: "2px solid white",
                              borderRadius: 10,
                              color: "white",
                              display: "flex",
                              marginRight: 65,
                            }}
                          >
                            laisser ca
                          </button>
                        )}

                        <a
                          onClick={() => {
                            if (prestations && prestations[0]) {
                              history.push({
                                pathname:
                                  "/prise-de-rendez-vous/" + prestations[0].id,
                                state: professionnel,
                              });
                            } else {
                              alert(
                                "Une erreur s'est produite, réessayer plus tard, ou contactez nous"
                              );
                            }
                          }}
                          className="raleway-normal-black-16px "
                          style={{ fontSize: "16px", alignSelf: "center" }}
                        >
                          <u>Modifier</u>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="row"
                style={{ flexDirection: size.width <= 428 && "column" }}
              >
                <div
                  class="col-50"
                  style={{
                    display: "flex",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                >
                  {professionnel &&
                  (professionnel.acompte == null ||
                    professionnel.acompte == 0) ? (
                    <input
                      onClick={() => {
                        history.push({
                          pathname: "/checkout/" + cart.id,
                          state: {
                            professionnel: professionnel,
                            prestations: prestations,
                          },
                        });
                      }}
                      type="submit"
                      class="bouton-plein border-1px-dove-gray sinscrire raleway-bold-eerie-black-14px btn"
                      style={{
                        height: 55,
                        //   marginTop: "20px",
                        color: "white",
                        marginRight: 30,
                      }}
                      value="Confirmer"
                    />
                  ) : (
                    <>
                      <button
                        class="bouton-plein border-1px-dove-gray"
                        style={{
                          height: 55,
                          maxWidth: 332,
                          marginRight: 30,
                          border: "none",
                        }}
                        onClick={() => {
                          history.push({
                            pathname: "/checkout/" + cart.id,
                            state: {
                              professionnel: professionnel,
                              prestations: prestations,
                            },
                          });
                        }}
                      >
                        <div class="prendre-rdv raleway-semi-bold-white-18px">
                          Payer un acompte de {calPrice()} €
                        </div>
                      </button>
                    </>
                  )}

                  {!loading ? (
                    <>
                      {size.width > 800 && (
                        <a
                          href
                          onClick={() => {
                            cancelCart();
                          }}
                        >
                          <p className="raleway-medium-eerie-black-15px">
                            <u>Annuler</u>
                          </p>
                        </a>
                      )}
                    </>
                  ) : (
                    <div
                      style={{ margin: "auto", padding: "60px 0px", width: 55 }}
                    >
                      <div class="loader" />
                    </div>
                  )}
                </div>
              </div>

              {!loading && size.width < 800 && (
                <a
                  href
                  onClick={() => {
                    cancelCart();
                  }}
                >
                  <p
                    className="raleway-medium-eerie-black-15px"
                    style={{ paddingTop: 20 }}
                  >
                    <u>Annuler</u>
                  </p>
                </a>
              )}
            </>
          ) : (
            <div style={{ margin: "auto", padding: "60px 0px", width: 55 }}>
              <div class="loader" />
            </div>
          )}
          <p style={{ color: "gray", fontSize: 12, marginTop: 30 }}>
            {professionnel.acompte == null || professionnel.acompte == 0
              ? ""
              : " Frais de services inclus : 1.00€"}
            <br /> On fleek ne garantie pas la disponibilité de l'employé
            sélectionné pour chaque prestation.
          </p>
        </div>
      </div>
    </>
  );
}

export default RecapRDV;
